import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceTypeService } from '../../../../services/service-type.service';
import { ServiceType } from '../../../../models/ServiceType';

@Component({
  selector: 'app-services-details',
  templateUrl: './services-details.component.html',
  styleUrls: ['./services-details.component.css']
})
export class ServicesDetailsComponent implements OnInit {
  service?: ServiceType;
  loading = false;
  error: string | null = null;
  serviceId!: number;

  constructor(
    private serviceTypeService: ServiceTypeService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.serviceId = +params['id'];
        this.loadService(this.serviceId);
      }
    });
  }

  loadService(id: number): void {
    this.loading = true;
    this.error = null;

    this.serviceTypeService.getById(id)
      .subscribe({
        next: (response) => {
          // Mapear campos PascalCase da API para camelCase
          const apiData: any = response.data;
          this.service = {
            id: apiData.Id,
            name: apiData.Name,
            description: apiData.Description,
            category: apiData.Category,
            estimatedTimeMinutes: apiData.EstimatedTimeMinutes,
            baseCost: apiData.BaseCost,
            currentCost: apiData.CurrentCost,
            profitMarginPercentage: apiData.ProfitMarginPercentage,
            isActive: apiData.IsActive,
            code: apiData.Code,
            createdAt: apiData.CreatedAt,
            updatedAt: apiData.UpdatedAt,
            createdBy: apiData.CreatedBy,
            updatedBy: apiData.UpdatedBy
          };
          this.loading = false;
        },
        error: (err) => {
          this.error = err.error?.error || 'Erro ao carregar detalhes do serviço';
          this.loading = false;
          console.error('Erro:', err);
        }
      });
  }

  calculateFinalPrice(): number {
    if (!this.service?.currentCost || !this.service?.profitMarginPercentage) {
      return this.service?.currentCost || 0;
    }
    const margin = this.service.profitMarginPercentage / 100;
    return this.service.currentCost + (this.service.currentCost * margin);
  }

  formatTime(minutes?: number): string {
    if (!minutes) return '-';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0) {
      return `${hours}h ${mins}min`;
    }
    return `${mins}min`;
  }

  toggleStatus(): void {
    if (!this.service) return;

    this.serviceTypeService.toggleStatus(this.service.id)
      .subscribe({
        next: () => {
          this.service!.isActive = !this.service!.isActive;
        },
        error: (err) => {
          console.error('Erro ao alterar status:', err);
          this.error = 'Erro ao alterar status do serviço';
        }
      });
  }

  editService(): void {
    this.router.navigate(['/operations/services/edit', this.serviceId]);
  }

  deleteService(): void {
    if (confirm('Deseja realmente excluir este serviço?')) {
      this.serviceTypeService.delete(this.serviceId)
        .subscribe({
          next: () => {
            this.router.navigate(['/operations/services']);
          },
          error: (err) => {
            console.error('Erro ao excluir:', err);
            this.error = 'Erro ao excluir serviço';
          }
        });
    }
  }

  goBack(): void {
    this.router.navigate(['/operations/services']);
  }
}

